module.exports = __webpack_public_path__ + "static/media/3x2_MCQ.eb138061.svg";